// Utils
import { required } from '@shopee/validators';

// Constants

// Types
import { TypedFormConfig } from '@shopee/use-form-hook';
import { BiometricsLoginByPasswordFormShape } from '@shopee-user/business-customization-types';

export const FORM_CONFIG: TypedFormConfig<BiometricsLoginByPasswordFormShape> = {
  password: {
    type: 'string',
    initialValue: '',
    validators: [required('msg_auth_mandatory_field')],
  },
};
